import { Dropdown } from "antd";
import styled from "styled-components";

export const StyledDropdown = styled(Dropdown)`
  width: fit-content;
  justify-content: start;

  .anticon {
    flex: 1;
    justify-content: flex-end;
  }
`;
